import React from "react";
import { Box, Collapse, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import humanMaleFemale from "@iconify/icons-mdi/human-male-female";
import ApplicationCollapseHeader from "my-tax/components/application-collapse-header";
import useStyles from "my-tax/components/dependents-collapse/dependents-collapse.style";
import { NOT_PROVIDED } from "my-tax/constants";
import { useRecoilState } from "recoil";
import { ocCollapseState } from "oc/states";
import formatTaxNumber from "oc/utils/format-tax-number";

interface MyTaxSpouseCollapseProps {
  editable: boolean;
  states: {
    spouseName?: string;
    spouseTaxNumber?: string;
    spouseEmployerName?: string;
    spouseEmployerTaxNumber?: string;
  };
  onChange: (change: { key: string; value: string }) => void;
  isMobile: boolean;
}

const MyTaxSpouseCollapse: React.FC<MyTaxSpouseCollapseProps> = ({
  editable,
  states,
  onChange,
  isMobile,
}) => {
  const theme = useTheme();

  const [expanded, setExpanded] = useRecoilState(
    ocCollapseState("spouseFilterCollapseExpanded")
  );

  const classes = useStyles(expanded);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box>
      <ApplicationCollapseHeader
        handleExpandClick={handleExpandClick}
        expanded={expanded}
        icon={humanMaleFemale}
        dependentName={states?.spouseName || ""}
        dependentTaxNumber={
          states?.spouseTaxNumber ? states?.spouseTaxNumber : NOT_PROVIDED
        }
        taxNumberLabel="Adóazonosító jele"
        isMobile={isMobile}
      />
      <Collapse in={expanded} timeout="auto">
        <Box className={classes.backgroundColor} padding="0px 16px">
          <Box className={classes.topBorder} />
          <Box display="flex" flexDirection="column" padding="16px 0px">
            <Typography variant="body1">
              Adóelőleget megállapító munkáltató, kifizető megnevezése
            </Typography>
            <Box height="16px" />
            <Box
              marginRight="16px"
              style={{
                borderRadius: "4px",
              }}
            >
              <TextField
                id="spouse-collapse-companyName"
                name="spouse-collapse-companyName"
                value={states?.spouseEmployerName || ""}
                style={{ width: isMobile ? "100%" : "467px" }}
                variant="outlined"
                label="Megnevezés"
                type="string"
                onChange={(e) => {
                  onChange({
                    key: "spouseEmployerName",
                    value: e.target.value,
                  });
                }}
                disabled={!editable}
                sx={{
                  background: theme.palette.white.main,
                }}
              />
              <Box height="36px" />
              <Typography variant="body1">
                Adóelőleget megállapító munkáltató, kifizető adószáma
              </Typography>
              <Box height="16px" />
              <Box
                marginRight="16px"
                style={{
                  borderRadius: "4px",
                }}
              >
                <TextField
                  id="spouse-collapse-companyTaxNumber"
                  name="spouse-collapse-companyTaxNumber"
                  value={formatTaxNumber(states?.spouseEmployerTaxNumber) || ""}
                  style={{ width: isMobile ? "100%" : "467px" }}
                  variant="outlined"
                  label="Adószám"
                  type="string"
                  onChange={(e) => {
                    onChange({
                      key: "spouseEmployerTaxNumber",
                      value: e.target.value,
                    });
                  }}
                  disabled={!editable}
                  sx={{
                    background: theme.palette.white.main,
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

export default MyTaxSpouseCollapse;
